import React from 'react';
import './aboutme.scss';
import { AboutMeData } from '../../Store';
import { Link } from 'react-router-dom';


const AboutMe = () => {
    const aboutMe = AboutMeData;
    return (
        <div className="about-me" key={aboutMe._id}>
            <div className="container">
                <div className="heading">
                        <h3>About Me</h3>
                        <div className="head-btn">
                        <Link role="button" to="/about" className="btn btn-primary btn-head">Lean More</Link>
                    </div>
                </div>
                <div className="sub-container">
                
                <div className="about-flex">
                    <div className="about-box left">
                        <p  dangerouslySetInnerHTML={{
                            __html: aboutMe.content
                        }} />
                        <ul>
                            {aboutMe.technology.map(tech => <li>{tech}</li>)}
                        </ul>
                    </div>
                    <div className="about-box right">
                        <div className="hero-img"><img src={aboutMe.image} alt=""/></div>
                        
                    </div>
                </div>
            </div>
            </div>
            
        </div>
    );
};

export default AboutMe;